import NavBar from "../../../components/organisms/navbar";
import { Container, Content, PaymentContainer, Title, Title2, InstructionTitle, InstructionList, InstructionItem, InstructionStep, InstructionItemContent, StyledLink, HighlightedLink } from "../styles";
import { FaWhatsapp } from "react-icons/fa";
import { useParams } from "react-router-dom";
import React from "react";

const PaymentEnrollmentIOrixicombatOpenJiuJitsu = () => {
    const { slug, id } = useParams();
    return (
        <Container>
            <NavBar />
            <Content>
                <PaymentContainer>
                    <Title>Obrigado por fazer a sua inscrição na</Title>
                    <Title2>
                        I ORIXICOMBAT OPEN JIU JITSU
                    </Title2>
                    <p style={{ color: "red", marginBottom: "0px" }}><b>Inscrição N° {id}</b></p>
                    <InstructionTitle>Instruções:</InstructionTitle>

                    <InstructionList>
                        {/* <InstructionItem color="#f0f4c3"> */}
                        <InstructionItem color="rgb(210, 210, 210)">
                            <InstructionStep>Passo 1</InstructionStep>
                            <InstructionItemContent>
                                Coloca o número da inscrição ( <b style={{ color: "red", marginBottom: "30px" }}>{id}</b> ) na descrição do PIX.
                            </InstructionItemContent>
                        </InstructionItem>

                        {/* <InstructionItem color="#e3f2fd"> */}
                        <InstructionItem color="rgb(210, 210, 210)">
                            <InstructionStep>Passo 2</InstructionStep>
                            <InstructionItemContent>
                                Efetuar o pagamento através do PIX para:
                                <ul style={{ listStyle: "none" }}>
                                    <br />
                                    <li>Banco NuBank</li>
                                    <li>Chave PIX telefone</li>
                                    <li><b>Pix: 93 984296581</b></li>
                                    <li>Luis Paulo Picanço Pena</li>
                                </ul>
                            </InstructionItemContent>
                        </InstructionItem>

                        <InstructionItem color="rgb(210, 210, 210)">
                            {/* <InstructionItem color="#ffecb3"> */}
                            <InstructionStep>Passo 3</InstructionStep>
                            <InstructionItemContent>
                                Enviar o comprovante de pagamento (com número da inscrição descrição)  para:
                                <ul style={{ listStyle: "none" }}>
                                    <li>
                                        <br />
                                        <StyledLink
                                            target="_blank"
                                            href={`https://whatsa.me/+5593991753303/?t=Ol%C3%A1%20Luis%20Paulo%20Pican%C3%A7o%20Pena,%20estou%20enviando%20o%20comprovante%20de%20pagamento%20referente%20a%20inscri%C3%A7%C3%A3o%20no%20*I%20ORIXICOMBAT%20OPEN%20JIU%2A%0A%0A%2AInscri%C3%A7%C3%A3o+N%C2%B0+${id}*`}
                                        >
                                            (93)99175-3303 <FaWhatsapp />
                                        </StyledLink>
                                    </li>
                                </ul>
                            </InstructionItemContent>
                        </InstructionItem>

                        <InstructionItem color="rgb(210, 210, 210)">
                            {/* <InstructionItem color="#c8e6c9"> */}
                            <InstructionStep>Passo 4</InstructionStep>
                            <InstructionItemContent>
                                Acompanhe o status do pagamento em:
                                <br />
                                <ul style={{ listStyle: "none" }}>
                                    <li>
                                        <HighlightedLink href="/profile/subscription">Minhas Inscrições</HighlightedLink>
                                    </li>
                                </ul>
                            </InstructionItemContent>
                        </InstructionItem>
                    </InstructionList>
                </PaymentContainer>
            </Content>
        </Container>
    )
}
export default PaymentEnrollmentIOrixicombatOpenJiuJitsu
